<template>
  <div class="footer">
    <v-footer
      app
      class="pa-3"
      color="rgba(0, 0, 0, 0.5)"
    >
      <p
        v-if="this.$route.name !== 'home' && this.$route.name !== 'movie' && this.$route.name !== 'bookmarks'"
        class="font-weight-light ma-0"
      >
        Suchergebnis: {{ getTotalResults }}
      </p>
      <p
        v-if="this.$route.name === 'bookmarks'"
        class="font-weight-light ma-0"
      >
        Favoriten: {{ getFavMovies }} Filme / {{ getFavPeople }} Personen
      </p>
      <v-spacer />
      <div class="footer__copyright">
        &copy; {{ new Date().getFullYear() }} GruneWalda
      </div>
    </v-footer>
  </div>
</template>


<script>

export default {

  computed: {
    getTotalResults() {
      switch (this.$route.name) {
        case 'search': return this.$store.getters.getQueryTotalRes;
        case 'param-search': return this.$store.getters.getParamsTotalRes;
        case 'movies': return this.$store.getters.getQuickTotalMovieRes(this.$route.name);
        default: return this.$store.getters.getQuickTotalRes(this.$route.name);
      }
    },
    getFavMovies() {
      return this.$store.getters.getFavMovies;
    },
    getFavPeople() {
      return this.$store.getters.getFavPeople;
    },
  },
};
</script>

<style lang="scss">
  .footer {
    &__copyright {
      @media(max-width: 360px) {
        display: none !important;
      }
    }
  }

</style>
